// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalBiResultSearchDefaultResponse {
    static getAttributeTypeMap() {
        return MedicalV1MedicalBiResultSearchDefaultResponse.attributeTypeMap;
    }
}
MedicalV1MedicalBiResultSearchDefaultResponse.discriminator = undefined;
MedicalV1MedicalBiResultSearchDefaultResponse.additionalProperties = false;
MedicalV1MedicalBiResultSearchDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "MedicalV1MedicalBiResultSearchDefaultResponseData"
    },
];
//# sourceMappingURL=medicalV1MedicalBiResultSearchDefaultResponse.js.map